<template>
  <help-dialog title="Card Type Settings" maxWidth="700px" :includeMargin="false">
    <template #activator="{ openDialog }">
      <v-btn
        size="small"
        variant="text"
        icon="mds:help"
        @click="openDialog"
        style="font-size: 20px;"
      />
    </template>
    <template #default>
      <h3 class="mb-2 text-black">Customize Your Workspace</h3>
      <p class="text-grey-darken-3">
        Card Type Settings allow you to configure your workspace according to your preferred framework
        or project methodology. You can tailor card types to match how your team works, whether you're
        using Event Storming, Event Modeling, Domain-Driven Design, or any other approach.
      </p>

      <br/><br/>

      <h3 class="mb-2 text-black">What Are Card Types?</h3>
      <p class="text-grey-darken-3">
        Card types define the different kinds of information you can attach to events in your workflow.
        Common examples include:
      </p>
      <br/>
      <ul class="pl-10">
        <li class="text-grey-darken-3"><b>User Stories</b> – For Agile/Scrum teams</li>
        <li class="text-grey-darken-3"><b>Test Cases</b> – Document testing requirements</li>
        <li class="text-grey-darken-3"><b>Commands / Read Models / Aggregate Roots</b> – For Domain-Driven Design</li>
        <li class="text-grey-darken-3"><b>Given-When-Then</b> – Capture acceptance criteria</li>
        <li class="text-grey-darken-3"><b>Problems/Opportunities</b> – For discovery workshops</li>
        <li class="text-grey-darken-3"><b>Tasks</b> – Implementation details</li>
      </ul>

      <br/><br/>

      <h3 class="mb-2 text-black">How to Customize</h3>
      <p class="text-grey-darken-3">
        For each card type, you can configure:
      </p>
      <br/>
      <ul class="pl-10">
        <li class="text-grey-darken-3">
          <b>Type Name & Description</b> – Define what this card type represents
        </li>
        <li class="text-grey-darken-3">
          <b>Color</b> – Visual distinction in the workflow diagram
        </li>
        <li class="text-grey-darken-3">
          <b>Show in Backlog</b> – Whether cards of this type appear in the backlog view
        </li>
        <li class="text-grey-darken-3">
          <b>Use AI</b> – Enable AI assistance to generate cards of this type
        </li>
        <li class="text-grey-darken-3">
          <b>Domain Model Role</b> – Assign special roles like Command, Aggregate Root, Read Model,
          Given-When-Then, or Tag
        </li>
      </ul>

      <br/><br/>

      <h3 class="mb-2 text-black">Tips</h3>
      <ul class="pl-10">
        <li class="text-grey-darken-3">
          <b>Start simple</b> – Begin with 3-5 card types and add more as needed
        </li>
        <li class="text-grey-darken-3">
          <b>Use consistent naming</b> – Match your team's terminology
        </li>
        <li class="text-grey-darken-3">
          <b>Drag to reorder</b> – Use the drag handle to organize card types by priority
        </li>
        <li class="text-grey-darken-3">
          <b>Set a default type</b> – Choose the most commonly used card type to save time
        </li>
        <li class="text-grey-darken-3">
          <b>Enable AI selectively</b> – Turn on AI for card types where automated generation is valuable
        </li>
        <li class="text-grey-darken-3">
          <b>Use Tags for filtering</b> – Card types with the Tag role use a tag input instead of free text,
          and can be used to filter the workflow view and backlog
        </li>
      </ul>
    </template>
  </help-dialog>
</template>

<script setup>
import HelpDialog from '@/components/HelpDialog.vue'
</script>
